import React from 'react';
import './sectionFour.scss';
import './platformLayersSection.scss';
import clientImg1 from '../../../resources/clients/client-1.svg';
import clientImg2 from '../../../resources/clients/client-2.svg';
import clientImg3 from '../../../resources/clients/client-3.svg';
import clientImg4 from '../../../resources/clients/client-4.svg';
import clientImg5 from '../../../resources/clients/client-5.svg';
import clientImg6 from '../../../resources/clients/client-6.svg';
import clientImg7 from '../../../resources/clients/client-7.svg';
import clientImg8 from '../../../resources/clients/client-8.svg';
import clientImg9 from '../../../resources/clients/client-9.svg';
import clientImg10 from '../../../resources/clients/client-10.svg';
import clientImg11 from '../../../resources/clients/client-11.svg';
import clientImg12 from '../../../resources/clients/client-12.svg';
import arrow from '../../../resources/arrow-2.png';


const CLIENT_LOGOS = [
	{ id: 'shell', src: clientImg1, alt: 'Shell' },
	{ id: 'deloitte', src: clientImg2, alt: 'Deloitte' },
	{ id: 'petroanalytica', src: clientImg3, alt: 'PetroAnalytica' },
	{ id: 'briley-group', src: clientImg4, alt: 'Briley Group' },
	{ id: 'almansoori', src: clientImg5, alt: 'Almansoori' },
	{ id: 'saudi-electricity', src: clientImg6, alt: 'Saudi Electricity Company' },
	{ id: 'sensia', src: clientImg7, alt: 'Sensia' },
	{ id: 'standard-chartered', src: clientImg8, alt: 'Standard Chartered' },
	{ id: 'uob', src: clientImg9, alt: 'UOB' },
	{ id: 'natsteel', src: clientImg10, alt: 'NatSteel' },
	{ id: 'renew-power', src: clientImg11, alt: 'ReNew Power' },
	{ id: 'risiko', src: clientImg12, alt: 'Risiko', dark: true },
];

const FLOW_STEPS = [
	{ id: 'data', label: 'Data', accent: 'blue' },
	{ id: 'ai', label: 'AI', accent: 'indigo' },
	{ id: 'decision', label: 'Decision', accent: 'green' },
	{ id: 'business', label: 'Business App', accent: 'orange' },
	{ id: 'execution', label: 'Execution', accent: 'gold' },
];

const OUTCOME_METRICS = [
	{ id: 'revenue', label: 'Revenue', direction: 'up' },
	{ id: 'margin', label: 'Margin', direction: 'up' },
	{ id: 'working-capital', label: 'Working Capital', direction: 'down' },
	{ id: 'cash-flow', label: 'Cash Flow', direction: 'up' },
];

const PLATFORM_LAYERS = [
	{
		id: 'data',
		name: 'Unified Enterprise Data',
		description: 'Trusted enterprise data foundation',
		accent: 'blue',
		items: ['Data Integration', 'Data Harmonization', 'Data Quality'],
	},
	{
		id: 'ai',
		name: 'Native AI Intelligence',
		description: 'Domain AI applications and optimization engines',
		accent: 'indigo',
		items: [
			'Demand Forecasting',
			'Production Optimizer',
			'Sales Management',
			'Supply Chain Efficiency',
			'KPI Optimizer',
		],
	},
	{
		id: 'decision',
		name: 'Decision Intelligence',
		description: 'Insights, explainability and decision support',
		accent: 'green',
		items: [
			'Anomaly Detection',
			'Root Cause Intelligence',
			'AskEPM Decision Support',
			'Prescriptive Actions',
			'Timely Alerts',
		],
	},
	{
		id: 'business',
		name: 'Business Applications',
		description: 'Planning and performance applications',
		accent: 'orange',
		items: [
			'Planning & MIS',
			'Command Center',
			'Working Capital',
			'Asset Management',
			'S&OP / Demand',
		],
	},
	{
		id: 'execution',
		name: 'Execution',
		description: 'Closed-loop action and accountability',
		accent: 'gold',
		items: [
			'Continuous Monitoring',
			'Growth / Initiatives',
			'Interventions',
			'Workflow Automation',
			'Collaboration',
		],
	},
	{
		id: 'security',
		name: 'Security',
		description: 'Enterprise-grade governance and resilience',
		accent: 'sage',
		items: ['RBAC', 'Data Encryption', 'Vulnerability Management', 'Audit & Compliance'],
	},
];

const FlowArrowIcon = () => (
	<svg
		className="platform-layers__flow-arrow-icon"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-hidden="true"
	>
		<path
			d="M8 2V13M8 13L3.5 8.5M8 13L12.5 8.5"
			stroke="currentColor"
			strokeWidth="1.6"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const SectionFour = () => {
	return (
		<div id="sectionFour-wrapper">
			<div className="sectionFour-client">
				<div className="heading">Extensive Global Client Experience</div>

				<div className="clientImg">
					{CLIENT_LOGOS.map((logo) => (
						<span
							className={`client-logo${logo.dark ? ' client-logo--dark' : ''}`}
							key={logo.id}
						>
							<img src={logo.src} alt={logo.alt} />
						</span>
					))}
				</div>

				<div className="stories-link">
					<a href="/resources">
						See Customer Success Stories
						<img id="sectionFour-arrow" src={arrow} alt="section-img-arrow" />
					</a>
				</div>
			</div>

			<section className="platform-layers" id="platform-layers">
				<div className="platform-layers__container">
					<header className="platform-layers__header">
						<h2 className="platform-layers__title">
							EACIIT EPMTech Platform –  <br />Modular Layers for Full Integration &amp;
							Continuous Optimization
						</h2>
						<span className="platform-layers__title-rule" aria-hidden="true" />
					</header>

					<div className="platform-layers__body">
						{/* ---------- Left column ---------- */}
						<div className="platform-layers__summary">
							<h3 className="platform-layers__summary-title">
								From data to measurable enterprise outcomes
							</h3>

							<p className="platform-layers__summary-text">
								Value is created when data, AI, decisions, business
								applications, and execution operate as one integrated
								performance system — enabling enterprise-wide optimization.
							</p>

							<div className="platform-layers__flow">
								{FLOW_STEPS.map((step, index) => (
									<React.Fragment key={step.id}>
										<div
											className={`platform-layers__flow-step platform-layers__flow-step--${step.accent}`}
										>
											{step.label}
										</div>
										{index < FLOW_STEPS.length - 1 && (
											<span className="platform-layers__flow-arrow">
												<FlowArrowIcon />
											</span>
										)}
									</React.Fragment>
								))}
							</div>

							<span className="platform-layers__summary-rule" aria-hidden="true" />

							<ul className="platform-layers__metrics">
								{OUTCOME_METRICS.map((metric) => (
									<li className="platform-layers__metric" key={metric.id}>
										{metric.label}
										<span
											className={`platform-layers__metric-arrow platform-layers__metric-arrow--${metric.direction}`}
											aria-hidden="true"
										>
											{metric.direction === 'up' ? '↑' : '↓'}
										</span>
									</li>
								))}
							</ul>
						</div>

						{/* ---------- Right column ---------- */}
						<div className="platform-layers__layers">
							<span className="platform-layers__eyebrow">Platform Layers</span>

							{PLATFORM_LAYERS.map((layer) => (
								<div
									className={`platform-layers__layer platform-layers__layer--${layer.accent}`}
									key={layer.id}
								>
									<div className="platform-layers__layer-heading">
										<h4 className="platform-layers__layer-name">
											{layer.name}
										</h4>
										<span
											className="platform-layers__layer-dot"
											aria-hidden="true"
										/>
										<p className="platform-layers__layer-description">
											{layer.description}
										</p>
									</div>

									<div className="platform-layers__pills">
										{layer.items.map((item) => (
											<span
												className={`eaciit-pill eaciit-pill--${layer.accent}`}
												key={item}
											>
												{item}
											</span>
										))}
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</section>
		</div>
	);
};

export default SectionFour;